var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0337 0.661285C22.7311 0.661507 24.103 2.03411 24.103 3.7316V6.90836C24.1031 7.24732 24.3832 7.52738 24.7222 7.5275C25.0612 7.5275 25.3413 7.24739 25.3413 6.90836C25.3413 5.21073 26.714 3.83804 28.4116 3.83804C30.1092 3.83812 31.481 5.21078 31.481 6.90836V22.8048C31.481 22.9877 31.5603 23.1599 31.7026 23.2834L31.7681 23.3332L31.771 23.3351C31.8475 23.3877 31.9544 23.4239 32.1001 23.424C32.1443 23.424 32.1902 23.4192 32.2339 23.4103L32.3589 23.3722C33.2271 22.9904 34.1983 22.7961 35.188 22.7961C36.7491 22.7961 38.2566 23.2556 39.4536 24.1105L40.4468 24.8205L39.3101 25.2658C38.4585 25.5996 37.5621 26.1744 36.9126 27.2043C36.268 28.2283 35.4258 30.2422 34.6792 32.2052C33.9465 34.1317 33.3318 35.9401 33.1304 36.55C33.1267 36.5645 33.1242 36.5793 33.1206 36.5939C33.1142 36.6195 33.1075 36.6455 33.1011 36.6711C31.9759 42.3864 26.8939 46.5235 21.0591 46.5236C15.2478 46.5236 10.1667 42.4103 8.97803 36.7228L8.97217 36.6974L8.96436 36.6662L8.95557 36.6496L8.94092 36.6046C8.81394 36.2237 8.20549 34.4138 7.45264 32.4211C6.69106 30.4052 5.81025 28.2789 5.14111 27.2179C4.49044 26.1858 3.60622 25.6119 2.74658 25.2794L1.59424 24.8341L2.60303 24.1212C3.8097 23.2695 5.30252 22.8088 6.86572 22.8087C7.85921 22.8087 8.84839 23.0045 9.72119 23.3908L9.73096 23.3947V23.3957C9.81582 23.4348 9.88854 23.4494 9.96631 23.4494C10.0664 23.4493 10.1871 23.4173 10.3149 23.3459C10.4876 23.2212 10.5854 23.0328 10.5854 22.8302V6.92105C10.5855 5.22354 11.9573 3.85187 13.6548 3.85172C15.3524 3.85172 16.7251 5.22345 16.7251 6.92105C16.7251 7.26012 17.0052 7.54019 17.3442 7.54019C17.6833 7.54016 17.9634 7.2601 17.9634 6.92105V3.7316C17.9634 2.03398 19.3361 0.661285 21.0337 0.661285Z",
    fill: "#0072A3",
    stroke: "#003B75",
    strokeWidth: 1.3234
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0762 4.80176C22.5206 4.80176 23.6807 5.97661 23.6807 7.41992V10C23.6808 10.2107 23.8539 10.3788 24.0527 10.3789C24.2516 10.3789 24.4247 10.2108 24.4248 10C24.4248 8.55674 25.585 7.38192 27.0293 7.38184C28.4737 7.38184 29.6338 8.55669 29.6338 10V22.9102C29.6338 23.007 29.6698 23.0991 29.7354 23.1719L29.8105 23.2383L29.8145 23.2402C29.8513 23.2657 29.9105 23.289 30.0059 23.2891C30.0327 23.2891 30.0609 23.2858 30.0879 23.2803L30.1631 23.2578C30.881 22.9403 31.682 22.7793 32.4971 22.7793C33.7821 22.7793 35.0254 23.1599 36.0146 23.8711L36.999 24.5791L35.8711 25.0244C35.2031 25.288 34.5047 25.74 33.998 26.5488C33.4855 27.3686 32.8091 28.9919 32.2061 30.5879C31.6208 32.1368 31.1293 33.592 30.9629 34.0986C30.9595 34.1122 30.9565 34.1261 30.9531 34.1396C30.948 34.1604 30.9426 34.1814 30.9375 34.2021C30.0161 38.8971 25.8661 42.2988 21.0967 42.2988C16.3369 42.2987 12.1808 38.9028 11.2188 34.2168H11.2178C11.217 34.2135 11.2165 34.2108 11.2158 34.208L11.2129 34.2012L11.1982 34.1562C11.0959 33.8472 10.6055 32.3796 9.99902 30.7637C9.38373 29.1243 8.67676 27.4091 8.14453 26.5596H8.14355C7.63569 25.7488 6.94694 25.2983 6.27344 25.0361L5.12988 24.5908L6.13086 23.8799C7.1274 23.1719 8.35835 22.79 9.64551 22.79C10.4638 22.7901 11.2798 22.9518 12.002 23.2734L12.0117 23.2783C12.0642 23.3027 12.104 23.3096 12.1465 23.3096C12.1986 23.3096 12.2698 23.2925 12.3525 23.248C12.4585 23.1702 12.5185 23.056 12.5186 22.9316V10.0098C12.5188 8.56666 13.6788 7.39259 15.123 7.39258C16.5673 7.39258 17.7273 8.56666 17.7275 10.0098C17.7275 10.2206 17.9007 10.3886 18.0996 10.3887C18.2985 10.3887 18.4717 10.2206 18.4717 10.0098V7.41992C18.4717 5.97664 19.6318 4.80181 21.0762 4.80176Z",
    fill: "#149E99",
    stroke: "#003B75",
    strokeWidth: 1.3234
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7124 22.8362C22.1486 22.4779 24.1342 22.982 25.7036 23.8089C27.2792 24.6391 28.4455 25.8004 29.2202 26.761C29.6066 27.2402 29.8927 27.6665 30.0815 27.971C30.1102 28.0171 30.1346 28.0616 30.1587 28.1018C23.5361 32.5883 18.7881 32.1679 15.7075 30.7024C14.1222 29.9482 12.9471 28.9029 12.1675 28.0432C11.7782 27.614 11.4896 27.2328 11.2993 26.9612C11.277 26.9294 11.2574 26.8981 11.2378 26.8694C14.5317 24.3492 17.3485 23.184 19.7124 22.8362Z",
    fill: "#003B75",
    stroke: "#F1ECE2",
    strokeWidth: 0.909676
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.161 26.4416C23.8585 24.5231 21.9673 23.1998 20.0488 23.5023C18.1303 23.8049 16.8069 25.6961 17.1095 27.6146C17.4121 29.5331 19.3033 30.8564 21.2218 30.5539C23.1403 30.2513 24.4636 28.3601 24.161 26.4416Z",
    fill: "#003B75",
    stroke: "#F1ECE2",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 31.3083L17.6607 28.987",
    stroke: "#003B75",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3887 20.1829L23.2638 23.1923",
    stroke: "#003B75",
    strokeWidth: 0.732219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0979 30.5587L19.4717 33.6575",
    stroke: "#003B75",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6622 23.06L21.4283 19.4982",
    stroke: "#003B75",
    strokeWidth: 0.732219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9498 33.3264L22.5946 30.0029",
    stroke: "#003B75",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8533 19.4823L18.2359 22.9752",
    stroke: "#003B75",
    strokeWidth: 0.732219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5539 30.9235L24.0386 28.042",
    stroke: "#003B75",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7147 20.7487L17.0259 23.1803",
    stroke: "#003B75",
    strokeWidth: 0.732219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0986 26.8968L24.2249 26.9689",
    stroke: "#F1ECE2",
    strokeWidth: 1.18321,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.fd2c16213cbff04e0ae8f1921dbc1712.svg";
export { ForwardRef as ReactComponent };